import { Alert } from '@mui/material';

import { MapSetupError } from './map-setup-error';
import { MapBaiduError } from './map-baidu-error';

export interface MapErrorProps {
  configError: 'setup' | 'google-key-missing' | 'baidu-key-missing';
  height: string | number;
  isUniversalMapsEnabled: boolean;
  hasGoogleKey: boolean;
  hasBaiduKey: boolean;
  errorMessage?: string;
}

export function MapError({
  configError,
  height,
  isUniversalMapsEnabled,
  hasGoogleKey,
  hasBaiduKey,
  errorMessage,
}: MapErrorProps) {
  switch (configError) {
    case 'setup':
      return (
        <MapSetupError
          height={height}
          isUniversalMapsEnabled={isUniversalMapsEnabled}
          hasGoogleKey={hasGoogleKey}
          hasBaiduKey={hasBaiduKey}
        />
      );

    case 'google-key-missing':
      return (
        <Alert severity="error" sx={{ height }}>
          {errorMessage}
        </Alert>
      );

    case 'baidu-key-missing':
      return <MapBaiduError height={height} />;

    default:
      return null;
  }
}
